import { HorizontalOrders } from '../../modules/wizards/components/horizontal-orders'

export function Orders() {
  return (
    <HorizontalOrders />
  )
}